export const PRIMARY_SITE_ORIGIN = 'https://oblitrok.com';
const WWW_HOST = 'www.oblitrok.com';

export function buildPrimarySiteUrl(pathname = '/', search = '', hash = '') {
  const cleanPath = pathname && pathname.startsWith('/') ? pathname : `/${pathname || ''}`;
  return `${PRIMARY_SITE_ORIGIN}${cleanPath}${search || ''}${hash || ''}`;
}

export function getPrimaryHostRedirectUrl(locationLike) {
  if (!locationLike || locationLike.hostname !== WWW_HOST) return '';
  return buildPrimarySiteUrl(locationLike.pathname || '/', locationLike.search || '', locationLike.hash || '');
}

export function redirectToPrimaryHost(win = window) {
  const target = getPrimaryHostRedirectUrl(win.location);
  if (!target) return false;
  win.location.replace(target);
  return true;
}
